'use strict';

angular.module('app').config(paymentMethodsRouting);

function paymentMethodsRouting($routeProvider) {
  $routeProvider.when('/payment_methods', {
    pageTitle: 'PAYMENT_METHODS',
    template: '<payment-methods-page></payment-methods-page>',
    breadcrumb: {
      label: 'COMPANY_SETTINGS',
      parent: 'ng/company_settings',
    },
    menu: 'settings',
    accessPermission: 'index_documenttype_accountadmin',
    authReq: true,
  });
}

paymentMethodsRouting.$inject = ['$routeProvider'];
